module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/portable4.webp";